import Aggregations from '../enums/Aggregations';
import { thresholdTypes } from './thresholds.types';
export var AggregationType;
(function (AggregationType) {
    /** Minimum */
    AggregationType["min"] = "min";
    /** Maximum */
    AggregationType["max"] = "max";
    /** Average */
    AggregationType["avg"] = "avg";
    /** Sum */
    AggregationType["sum"] = "sum";
    /** Circular average (mainly for wind average calculations) */
    AggregationType["circular_avg"] = "circular_avg";
    /** Median */
    AggregationType["median_avg"] = "median_avg";
})(AggregationType || (AggregationType = {}));
export var HydricStressTrend;
(function (HydricStressTrend) {
    /** forte diminution */
    HydricStressTrend[HydricStressTrend["highDecrease"] = -2] = "highDecrease";
    /** faible diminution */
    HydricStressTrend[HydricStressTrend["slightDecrease"] = -1] = "slightDecrease";
    /** stabilité */
    HydricStressTrend[HydricStressTrend["stable"] = 0] = "stable";
    /** faible augmentation */
    HydricStressTrend[HydricStressTrend["slightIncrease"] = 1] = "slightIncrease";
    /** forte augmentation */
    HydricStressTrend[HydricStressTrend["highIncrease"] = 2] = "highIncrease";
})(HydricStressTrend || (HydricStressTrend = {}));
export const isHydricStressTuple = (val) => {
    return (Array.isArray(val) &&
        val.length === 3 &&
        typeof val[0] === 'number' &&
        thresholdTypes.includes(val[1]) &&
        (val[2] === null || typeof val[2] === 'number'));
};
export const hydricStressAggregation = [
    Aggregations.latest,
    Aggregations.yesterday,
    Aggregations.today,
    Aggregations.week
];
export const isHydricStressAggregation = (val) => {
    return (val !== null &&
        val !== undefined &&
        hydricStressAggregation.includes(val));
};
export const isHydricDeficitTuple = (val) => {
    return (Array.isArray(val) &&
        val.length === 2 &&
        typeof val[0] === 'number' &&
        thresholdTypes.includes(val[1]));
};
//important to stay here to optimize js since computation of regex pattern is heavy it should not be done inside function call
const finishBy_N = /_N$/;
const finishBy_X = /_X$/;
const finishBy_L = /_L$/;
const finishBy_4H = /_4H$/;
const finishBy_H = /_H$/;
const finishBy_DD = /_DD$/;
const finishBy_3D = /_3D$/;
const finishBy_5D = /_5D$/;
const finishBy_7D = /_7D$/;
const finishBy_D = /_D$/;
const finishBy_i = /_[A-Z]+i$/;
const finishBy_LV = /_LV$/;
export function fromSummaryValuesKeyToMetric(key) {
    return key
        .replace(finishBy_N, '')
        .replace(finishBy_X, '')
        .replace(finishBy_L, '')
        .replace(finishBy_4H, '')
        .replace(finishBy_H, '')
        .replace(finishBy_DD, '')
        .replace(finishBy_3D, '')
        .replace(finishBy_5D, '')
        .replace(finishBy_7D, '')
        .replace(finishBy_D, '')
        .replace(finishBy_i, '')
        .replace(finishBy_LV, '');
}
/** checks if the given Summary is a PlotSummary */
export const isPlotSummary = (summary) => {
    return 'plot' in summary.metadata;
};
/** checks if the given Summary is a DeviceSummary */
export const isDeviceSummary = (summary) => {
    return 'device' in summary.metadata;
};
/** checks if the given Summary is a DeviceSummary */
export const isStationSummary = (summary) => {
    return 'station' in summary.metadata;
};
